// extracted by mini-css-extract-plugin
export var cartIcon = "_p8-0";
export var cartIconContainer = "_p8-1";